<div class="main-layouts-container">
  <sf-header/>
  <router-outlet/>
  <sf-footer/>
  <sf-tm-preview/>
</div>
